import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

export default class LoginPopupComponent extends Component {
  get SELECTORS() {
    return {
      textCloseBtn: '[data-text-close]',
      textContainer: '[data-text-container]',
      loginTogglerButton: '#loginTogglerButton',
      loginInnerTextToggler: '[data-login-toggle-inner]',
      popupCloseBtn: '[data-popup-close]',
      loginPopup: '[data-login-popup]',
      loginPopupBackdrop: '[data-login-popup-backdrop]',
    };
  }

  get COOKIE_NAME() {
    return {
      popupTextClose: 'login_popup_text_close',
      popupLoginClose: 'login_popup_close',
      popupLoginFirstClose: 'login_popup_first_close',
    };
  }

  get CLASSES() {
    return {
      hidden: '--hidden',
      show: '--show',
      shownButton: '--shownButton',
    };
  }

  constructor(compEl) {
    super(compEl);
    //popup constants
    this.loginPopupTimer = this.$component.dataset.loginPopupTimer
      ? this.$component.dataset.loginPopupTimer
      : 10000;
    this.loginFloatingIconTimer = this.$component.dataset.loginFloatingIconTimer
      ? this.$component.dataset.loginFloatingIconTimer
      : 20000;
    //elements
    this.textCloseBtn = this.$component.querySelector(
      this.SELECTORS.textCloseBtn
    );
    this.textContainer = this.$component.querySelector(
      this.SELECTORS.textContainer
    );
    this.popupCloseBtn = this.$component.querySelector(
      this.SELECTORS.popupCloseBtn
    );
    this.loginTogglerButton = this.$component.querySelector(
      this.SELECTORS.loginTogglerButton
    );
    this.loginInnerTextToggler = this.$component.querySelector(
      this.SELECTORS.loginInnerTextToggler
    );
    this.loginPopup = this.$component.querySelector(this.SELECTORS.loginPopup);
    this.loginPopupBackdrop = this.$component.querySelector(
      this.SELECTORS.loginPopupBackdrop
    );
  }

  handlePopupTextClose() {
    //the cookie already exists, hide text section
    if (Cookies.get(this.COOKIE_NAME.popupTextClose)) {
      this.textContainer.classList.add(this.CLASSES.hidden);
    }

    this.textCloseBtn.addEventListener('click', () => {
      //set cookie
      Cookies.set(this.COOKIE_NAME.popupTextClose, '1');
      //hide text container
      this.textContainer.classList.add(this.CLASSES.hidden);
    });
  }

  handleLoginTogglerClick() {
    this.loginTogglerButton.addEventListener('click', () => {
      this.loginPopupOpen();
    });
    if (this.loginInnerTextToggler)
      this.loginInnerTextToggler.addEventListener('click', () => {
        this.loginPopupOpen();
      });
  }

  loginPopupOpen() {
    this.loginPopup.classList.add(this.CLASSES.show);
    this.loginPopupBackdrop.classList.add(this.CLASSES.show);
    this.$component.classList.remove(this.CLASSES.shownButton);
  }

  hideFloatingButton() {
    if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
      this.textContainer.classList.add(this.CLASSES.hidden);
    }
    this.loginTogglerButton.classList.add(this.CLASSES.hidden);
    this.$component.classList.remove(this.CLASSES.shownButton);
  }

  showFloatingButton() {
    this.loginTogglerButton.classList.remove(this.CLASSES.hidden);
    this.$component.classList.add(this.CLASSES.shownButton);
  }

  loginPopupClose() {
    this.popupCloseBtn.addEventListener('click', () => {
      Cookies.set(this.COOKIE_NAME.popupLoginClose, '1');
      this.loginPopup.classList.remove(this.CLASSES.show);
      this.loginPopupBackdrop.classList.remove(this.CLASSES.show);
      this.showFloatingButton();
      // If there is not the cookie that check it was a first time that the login pop-up is closed
      if (!Cookies.get(this.COOKIE_NAME.popupLoginFirstClose)) {
        // set the cookie
        Cookies.set(this.COOKIE_NAME.popupLoginFirstClose, '1');
        // set a timeout with the wait time to show the text of the floating button
        setTimeout(() => {
          if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
            this.textContainer.classList.remove(this.CLASSES.hidden);
          }
        }, this.loginFloatingIconTimer);
      }
    });
  }

  initModalLogin() {
    // Check if there's the login error query parameter
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loginError = urlParams.get('loginerror');
    //error in the login modal, show it
    if (`${loginError}` === 'true') {
      this.loginPopupOpen();
    } else {
      if (!Cookies.get(this.COOKIE_NAME.popupLoginClose)) {
        // show login popup after timeout
        setTimeout(() => {
          this.loginPopupOpen();
        }, this.loginPopupTimer);
      } else {
        if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
          this.textContainer.classList.remove(this.CLASSES.hidden);
        }
        this.loginTogglerButton.classList.remove(this.CLASSES.hidden);
        this.$component.classList.add(this.CLASSES.shownButton);
      }
    }
  }

  bindEvents() {
    this.handlePopupTextClose();
    this.loginPopupClose();
    this.handleLoginTogglerClick();

    this.$on(this.$customEvents.LOGIN_POPUP_EVENTS.hideFloatingIcon, () => {
      this.hideFloatingButton();
    });
    this.$on(this.$customEvents.LOGIN_POPUP_EVENTS.showFloatingIcon, () => {
      this.showFloatingButton();
    });

    // If Cookie banner is already accepted
    if (Cookies.get('cookies-disclaimer-v1')) {
      this.initModalLogin();
    } else {
      // Await Cookie banner accept event
      this.$on(this.$customEvents.COOKIE.accepted, () => {
        this.initModalLogin();
      });
    }
  }

  render() {
    this.bindEvents();
  }
}
